import Vue from 'vue'
import en from '@/translations/en'

const translations = {
    install () {
        Vue.prototype.$translations = en
    }
}
  
Vue.use(translations)


// WEBPACK FOOTER //
// ./src/plugins/translations.js